__turbopack_context__.v({
  "k1PackageStatusCell": "K1PackageStatusCell-module__8uIw8a__k1PackageStatusCell",
  "statusIcon": "K1PackageStatusCell-module__8uIw8a__statusIcon",
});
